import imageDe from '../images/de/uploader-abbottNeo-4.png';
import imageEn from '../images/en/uploader-abbottNeo-4.png';
import imageEs from '../images/es/uploader-abbottNeo-4.png';
import imageFi from '../images/fi/uploader-abbottNeo-4.png';
import imageFr from '../images/fr/uploader-abbottNeo-4.png';
import imageIt from '../images/it/uploader-abbottNeo-4.png';
import imageNo from '../images/no/uploader-abbottNeo-4.png';
import imageSv from '../images/sv/uploader-abbottNeo-4.png';

export const uploaderFinishImage = {
  de() {
    return imageDe;
  },
  en() {
    return imageEn;
  },
  es() {
    return imageEs;
  },
  fi() {
    return imageFi;
  },
  fr() {
    return imageFr;
  },
  it() {
    return imageIt;
  },
  no() {
    return imageNo;
  },
  sv() {
    return imageSv;
  },
};
